
export const COLORS = [
    'lightblue',
    'lightgreen',
    'orange',
    'pink',
    'silver',
    'teal',
    'violet',
    'white',
];

export const ICONS = [
    'baby',
    'bell',
    'bone',
    'broom',
    'bus',
    'bug',
    'camera',
    'campground',
    'candy-cane',
    'cat',
    'cloud',
    'coffee',
    'dice',
    'dragon',
    'couch',
    'crown',
    'egg',
    'fish',
    'hippo',
    'home',
    'helicopter',
    'heart',
    'ice-cream',
    'marker',
    'mitten',
    'moon',
    'motorcycle',
    'music',
    'paw',
    'piggy-bank',
    'plane',
    'ribbon',
    'rocket',
    'ship',
    'sleigh',
    'smile',
    'socks',
    'spider',
    'star',
    'sun',
    'toolbox',
    'tractor',
    'tree',
    'truck',
    'water',
    'snowflake',
    'snowman',
    'snowplow',
];

export const APP_ICON = 'rocket';
export const ITEM_COUNT = 3;
export const ROW_COUNT = 2;
export const ACTION_TIMER = 1500;
export const VOICE_OPTIONS = { rate: 0.75, pitch: 2 };
export const CORRECT_TEXT = [
    'Hurray!\nYou found the ',
    'Great!\nYou found the ',
    'Amazing!\nYou found the ',
    'Awesome!\nYou found the ',
    'Correct!\nYou found the ',
    'That\'s it!\nYou found the ',
    'Way to go!\nYou found the ',
];